// Module
var code = "<div class=nlgTenant ng-if=ctrl.enabled> <input class=form-control placeholder=tenant name=ctrl.tenantId ng-model=ctrl.tenantId ng-change=ctrl.change()> </div>";
// Exports
module.exports = code;